import { Component, Input } from "@angular/core";

import { Provider } from "@models/mood/general/provider";

@Component({
  selector: 'mood-metainfo-provider',
  templateUrl: 'metainfo-provider.component.html',
  styleUrls: ['metainfo-provider.component.scss']
})
export class DatasetMetainfoProviderComponent {
  @Input() provider!: Provider;

  constructor() { }
}
